/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
// import { useDispatch } from 'react-redux';
// import { useHistory } from 'react-router-dom';
import dayjs from 'dayjs';

import { Button, Col, Row } from 'antd';
import { numberWithSpacesInter } from '../../helpers/formatInteger';

import { ReactComponent as Arrow } from '../../assets/arrow-up-right.svg';
import { ReactComponent as Edit } from '../../assets/edit-icon.svg';
import { ReactComponent as Delete } from '../../assets/delete-black-icon.svg';

import SessionService from '../../services/SessionService';
import StorageService from '../../services/StorageService';
import DeleteStageItem from './DeleteStageItem';
import { questions } from '../../constants/fpQuestionObj';

const ItemsListItem = ({
  item,
  selected,
  setSelectedPlanItems,
  type,
  stageId,
  setOpenModalCreateItem,
}) => {
  const { t } = useTranslation('');

  // eslint-disable-next-line no-undef
  const baseURL = process.env.REACT_APP_BASE_URL;
  const token = StorageService.getJWTToken() || SessionService.getJWTToken();
  const imagePath = `${baseURL}/v1/financialplan/image/${item.image}`;

  const [imgSrc, setImgSrc] = useState(
    `/img/${type}/${item.category.toLowerCase()}.png`,
  );

  const [itemDelete, setItemDelete] = useState(null);

  const handleSelectItem = (event) => {
    event.preventDefault();
    setSelectedPlanItems(item.id);
  };

  const handleClose = () => {
    setSelectedPlanItems('sds');
  };

  const hendleEdit = () => {
    setOpenModalCreateItem({
      currentItemType: type,
      globalCategory: item.global_category,
      itemId: item.id,
    });
  };

  const handleDelete = () => {
    setItemDelete(item.id);
  };
  const handleDeleteClose = () => {
    setItemDelete(null);
  };

  const getType = (id) => {
    return ['ONE_TIME', 'MONTHLY', 'ANNUAL'][id];
  };

  useEffect(() => {
    if (item.image) {
      fetch(imagePath, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.blob();
        })
        .then((blob) => {
          const objectURL = URL.createObjectURL(blob);
          setImgSrc(objectURL);
        })
        .catch((error) => {
          console.error(
            'There was a problem with your fetch operation:',
            error,
          );
        });
    }
  }, [item]);

  // const getStageItemSumm = () => {
  //   const currentYear = dayjs().year();
  //   const startYear = dayjs(item.start_date).year();
  //   const endYear = dayjs(item.end_date).year();

  //   let amountToShow;
  //   if (currentYear === startYear) {
  //     amountToShow = item.start_year_amount;
  //   } else if (currentYear === endYear) {
  //     amountToShow = item.end_year_amount;
  //   } else {
  //     amountToShow = item.intermediate_year_amount;
  //   }

  //   // Если нужные поля отсутствуют — считаем 0
  //   if (amountToShow === undefined || amountToShow === null) {
  //     amountToShow = 0;
  //   }

  //   return numberWithSpacesInter(amountToShow, 0) + ' kr';
  // };

  return (
    <Row
      onClick={!selected ? handleSelectItem : null}
      className={selected ? 'finplan-items-row selected' : 'finplan-items-row'}
    >
      {!selected ? (
        <React.Fragment>
          <Col className="finplan-items-name">
            <div className="hover-dot" />
            {item.name}
          </Col>
          <Col className="finplan-items-frequency">
            {t(getType(item.frequency))}
          </Col>
          <Col className="finplan-items-amount">
            {numberWithSpacesInter(item?.amount, 0)} kr
          </Col>
          <Col className="finplan-items-start">
            {dayjs(item.start_date).format('YYYY')}
          </Col>
          <Col className="finplan-items-end">
            {dayjs(item.end_date).format('YYYY')}
          </Col>
        </React.Fragment>
      ) : (
        <div className="finplan-items-card-wrap">
          <div className="finplan-items-card-info">
            <h3 className="card-info-title">{item.name}</h3>
            <p className="card-info-endtime">
              {item.frequency !== 0
                ? `${dayjs(item.start_date).format('MMM YYYY')} - `
                : ''}
              {`${dayjs(item.end_date).format('MMM YYYY')}`}
              <span>{t(getType(item.frequency))}</span>
            </p>
            <p className="card-info-amount">
              {numberWithSpacesInter(item.amount, 0)} kr
            </p>
            <div className="info-count-wrapper">
              {type === 'expenses' ? (
                <>
                  {(item.global_category === 'daily_life' ||
                    item.global_category === 'giving_legacy') && (
                    <div className="info-count-cell">
                      <p className="info-count-title">{t('NECESSITY')}</p>
                      <div className="info-count-dig">
                        {t(questions?.necessity?.[item.necessity])}
                      </div>
                    </div>
                  )}
                  {(item.global_category === 'giving_legacy' ||
                    item.global_category === 'lifestyle_experiences') && (
                    <div className="info-count-cell">
                      <p className="info-count-title">{t('PURPOSE')}</p>
                      <div className="info-count-dig">
                        {t(questions?.purpose?.[item.purpose])}
                      </div>
                    </div>
                  )}
                  {item.global_category === 'lifestyle_experiences' && (
                    <div className="info-count-cell">
                      <p className="info-count-title">{t('HAPPINESS')}</p>
                      <div className="info-count-dig">
                        {t(questions?.happiness?.[item.happiness])}
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <>
                  <div className="info-count-cell">
                    <p className="info-count-title">{t('PROBABILITY')}</p>
                    <div className="info-count-dig">
                      {t(questions?.probability?.[item.probability])}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="finplan-items-card-img">
            {imgSrc && <img src={imgSrc} alt="expenses img" className="" />}
          </div>
          <div className="finplan-items-card-action">
            <Button
              type="text"
              icon={<Arrow />}
              iconPosition="end"
              onClick={handleClose}
              className="finplan-items-close-btn"
            >
              {t('CLOSE')}
            </Button>
            <div style={{ display: 'flex', gap: '16px' }} className="">
              <Button type="text" onClick={hendleEdit}>
                <Edit />
              </Button>
              <Button type="text" onClick={handleDelete}>
                <Delete />
              </Button>
            </div>
          </div>
        </div>
      )}
      <DeleteStageItem
        stageId={stageId}
        itemType={type}
        modalDeleteItem={itemDelete}
        handleDeleteClose={handleDeleteClose}
      />
    </Row>
  );
};

export default ItemsListItem;

ItemsListItem.propTypes = {
  item: PropTypes.object,
  userId: PropTypes.string,
  finplanId: PropTypes.string,
  selected: PropTypes.bool,
  setSelectedPlanItems: PropTypes.func,
  setOpenModalCreateItem: PropTypes.func,
  type: PropTypes.string,
  stageId: PropTypes.string,
};
